export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] text-white pt-12 sm:pt-16 pb-6 sm:pb-8">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br from-[#3B82F6] to-[#2563EB] flex items-center justify-center">
                <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
                  <i className="ri-drop-line text-white text-xl sm:text-2xl"></i>
                </div>
              </div>
              <span className="text-xl sm:text-2xl font-bold">Fontanería Pro</span>
            </div>
            <p className="text-gray-300 text-xs sm:text-sm leading-relaxed mb-4 sm:mb-6">
              Expertos en fontanería profesional. Calidad, confianza y servicio excepcional garantizado.
            </p>
            <div className="flex gap-2 sm:gap-3">
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/10 hover:bg-[#3B82F6] flex items-center justify-center transition-colors cursor-pointer">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                  <i className="ri-facebook-fill text-sm sm:text-base"></i>
                </div>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/10 hover:bg-[#3B82F6] flex items-center justify-center transition-colors cursor-pointer">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                  <i className="ri-instagram-line text-sm sm:text-base"></i>
                </div>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/10 hover:bg-[#3B82F6] flex items-center justify-center transition-colors cursor-pointer">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                  <i className="ri-twitter-x-line text-sm sm:text-base"></i>
                </div>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/10 hover:bg-[#3B82F6] flex items-center justify-center transition-colors cursor-pointer">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                  <i className="ri-linkedin-fill text-sm sm:text-base"></i>
                </div>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Enlaces Rápidos</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button onClick={() => scrollToSection('inicio')} className="text-gray-300 hover:text-[#3B82F6] transition-colors text-xs sm:text-sm cursor-pointer">
                  Inicio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('nosotros')} className="text-gray-300 hover:text-[#3B82F6] transition-colors text-xs sm:text-sm cursor-pointer">
                  Nosotros
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('servicios')} className="text-gray-300 hover:text-[#3B82F6] transition-colors text-xs sm:text-sm cursor-pointer">
                  Servicios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('galeria')} className="text-gray-300 hover:text-[#3B82F6] transition-colors text-xs sm:text-sm cursor-pointer">
                  Galería
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonios')} className="text-gray-300 hover:text-[#3B82F6] transition-colors text-xs sm:text-sm cursor-pointer">
                  Testimonios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contacto')} className="text-gray-300 hover:text-[#3B82F6] transition-colors text-xs sm:text-sm cursor-pointer">
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Servicios</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li className="text-gray-300 text-xs sm:text-sm">Reparaciones de Emergencia</li>
              <li className="text-gray-300 text-xs sm:text-sm">Instalación de Tuberías</li>
              <li className="text-gray-300 text-xs sm:text-sm">Remodelación de Baños</li>
              <li className="text-gray-300 text-xs sm:text-sm">Detección de Fugas</li>
              <li className="text-gray-300 text-xs sm:text-sm">Mantenimiento Preventivo</li>
              <li className="text-gray-300 text-xs sm:text-sm">Fontanería Comercial</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Contacto</h3>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-[#3B82F6] text-sm sm:text-base"></i>
                </div>
                <div>
                  <div className="text-xs sm:text-sm text-gray-400 mb-0.5 sm:mb-1">Teléfono</div>
                  <a href="tel:640920362" className="text-sm sm:text-base text-white font-semibold hover:text-[#3B82F6] transition-colors">
                    640 920 362
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-[#3B82F6] text-sm sm:text-base"></i>
                </div>
                <div>
                  <div className="text-xs sm:text-sm text-gray-400 mb-0.5 sm:mb-1">Email</div>
                  <a href="mailto:fontaneriaelrapido@gmail.com" className="text-xs sm:text-sm text-white font-semibold hover:text-[#3B82F6] transition-colors break-all">
                    fontaneriaelrapido@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-[#3B82F6] text-sm sm:text-base"></i>
                </div>
                <div>
                  <div className="text-xs sm:text-sm text-gray-400 mb-0.5 sm:mb-1">Ubicación</div>
                  <p className="text-sm sm:text-base text-white font-semibold">Valladolid, España</p>
                </div>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-[#3B82F6] text-sm sm:text-base"></i>
                </div>
                <div>
                  <div className="text-xs sm:text-sm text-gray-400 mb-0.5 sm:mb-1">Servicio de Emergencia</div>
                  <p className="text-sm sm:text-base text-white font-semibold">24 Horas</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 border-t border-white/10 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
        <p className="text-white/70 text-xs sm:text-sm text-center md:text-left">
          © {new Date().getFullYear()} Fontanería El Rápido. Todos los derechos reservados.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
          <a href="/politica-de-privacidad" className="text-gray-400 hover:text-[#3B82F6] text-xs sm:text-sm transition-colors cursor-pointer">
            Política de Privacidad
          </a>
          <a href="/politica-de-privacidad" className="text-gray-400 hover:text-[#3B82F6] text-xs sm:text-sm transition-colors cursor-pointer">
            Términos y Condiciones
          </a>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-[#3B82F6] text-xs sm:text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
